export const ITEM_TYPES = ["HU", "TU"];

export const ITEM_TYPE_ICONS = {
  TU: "cube",
  HU: "box",
  UOM: "plus" // if baseUOMS are added
};

export const ITEM_UNIT_TYPES = ["container", "truck", "pal", "box", "custom"];

export const TAXABLE_OPTIONS_KEYS = ["pal", "lm", "kg", "cm"];

export const DEFAULT_UNITS = [
  {
    type: "TU",
    description: "20 Ft",
    code: "22G1",
    itemType: "container",
    calcSettings: {
      itemize: false,
      costRelevant: true
    }
  },
  {
    type: "TU",
    description: "40 Ft",
    code: "42G1",
    itemType: "container",
    calcSettings: {
      itemize: false,
      costRelevant: true
    }
  },
  {
    type: "TU",
    description: "45 Ft",
    code: "L2G1",
    itemType: "container",
    calcSettings: {
      itemize: false,
      costRelevant: true
    }
  },
  {
    type: "TU",
    description: "Semi-trailer",
    code: "ST",
    itemType: "truck",
    calcSettings: {
      itemize: true,
      costRelevant: true
    }
  },
  {
    type: "TU",
    description: "Delivery-Van",
    code: "VAN",
    itemType: "truck",
    calcSettings: {
      itemize: true,
      costRelevant: true
    }
  },
  {
    type: "HU",
    description: "Pallet",
    code: "PAL",
    itemType: "pal",
    taxKeys: {
      pal: 1,
      lm: 0.8,
      kg: 500
    },
    calcSettings: {
      itemize: false,
      costRelevant: true
    }
  },
  {
    type: "HU",
    description: "Box",
    code: "BOX",
    itemType: "box",
    taxKeys: {
      box: null
    },
    calcSettings: {
      itemize: false,
      costRelevant: true
    }
  },
  {
    type: "HU",
    description: "parcel box",
    code: "PARCEL",
    itemType: "box",
    isPackingUnit: true,
    dimensions: {
      uom: "cm",
      length: 60,
      width: 60,
      height: 60
    }
  }
];

export const SHIPMENT_ITEMS_DEFAULTS = {
  calcSettings: {
    costRelevant: true,
    itemize: true
  }
};
